<template>
    <div class="capital_flow_outside hexiaoStaff">
      <p>分销员认证</p>
      <div class="capital_flow_container">
        <!-- 条件筛选 -->
        <el-form ref="conditionForm" :model="conditionForm" label-width="85px" :inline="true" class="demo-form-inline">
          <el-form-item label="分销员姓名">
	            <el-input v-model="conditionForm.name" placeholder="分销员姓名"  class="w160" size="small"></el-input>
	          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="conditionForm.status" placeholder="请选择状态类型">
              <el-option label="全部"  value=""></el-option>
              <el-option
              v-for="item in status_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="审核时间">
            <el-date-picker
              v-model="timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="changeTime"
              >
            </el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="searchData">开始检索</el-button>
            <el-button @click="onReset">重置检索</el-button>
          </el-form-item>
        </el-form>
      
        <el-table
          :data="staffData"
          style="width: 100%">
       
           <el-table-column
            prop="name"
            label="姓名"
            >
          </el-table-column>
          <el-table-column
            prop="title"
            label="活动来源"
            >
            <div slot-scope="scope" >
              <span :title="scope.row.title ">{{scope.row.title | ellipsis}}</span>
            </div>
          </el-table-column>
          <el-table-column align="center"
            label="分销员类型"
            >
            <template slot-scope="scope">
              <span class="whd-block">{{scope.row.user_type_text}}</span>
              <el-link type="primary" :underline="false" @click="getStaffInfo(scope.row.id, scope.row.user_type)">分销数据({{scope.row.buy_count}}单)</el-link>
            </template>
          </el-table-column>
           <el-table-column
            prop="tel"
            label="手机号"
            >
          </el-table-column>
           <el-table-column
            prop="nickname"
            label="微信昵称"
            >
          </el-table-column>
          <el-table-column
            prop="avatar"
            label="微信头像"
            >
            <template slot-scope="scope">
	            <img :src="scope.row.avatar" alt width="60px" height="60px" v-if="scope.row.avatar"/>
	            <img src="@/assets/imgs/userDefult.png" alt width="60px" height="60px" v-else/>
	          </template>
          </el-table-column>
          <el-table-column label="注册时间" prop="create_time_text"></el-table-column>
          <el-table-column label="状态" prop="status_text">
            <template slot-scope="scope">
              <span :class="'status'+scope.row.status">{{scope.row.status_text}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" >
						<template slot-scope="scope">
							<!-- <el-button type="primary" size="small" icon="el-icon-edit"  @click="publish('open', scope.row.activity_id, scope.row.tmp_id)">编辑</el-button> -->
							<!-- <el-button type="primary" size="small"   @click="shenhe(scope.row.id,scope.row.status)" :disabled="scope.row.status==0 ?false:true">审核</el-button> -->
							<el-button type="primary" size="small"   @click="shenhe(scope.row.id,scope.row.status)" v-if="scope.row.status==0">审核</el-button>
              <el-button type="primary" size="small"  @click="changeRecommend(scope.row.id,5)">删除</el-button>     
						</template>
        	</el-table-column> 
        </el-table>
        <el-pagination
          background
          layout="total,prev, pager, next"
          :current-page ='pages.current_page'
          :page-size='pages.page_size' 
          :pager-count='pages.page_count' 
          :page-count="pages.total_pages"
          :total="pages.total"
          @current-change= "currentChange">
        </el-pagination>
      </div>
      <div class="fenxiao_mask" v-if="isshowDialog">
        <div class="fenxiao_mask_content">
          <shenhe :shenheinfo="shenheinfo"  :isshowDialog.sync="isshowDialog" @updateData="updateData"></shenhe>
        </div>
      </div>

      <!-- 查看分销数据 -->
      <el-dialog v-if="dialogTableVisible" :title="recordData.name+'的分销数据'" :visible.sync="dialogTableVisible">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <el-avatar class="whd-block" :size="60" :src="recordData.avatar"></el-avatar>
          </div>
          <div class="weui-cell__bd pl20 whd-tleft">
            {{recordData.name}}<br/>{{recordData.user_type==1?'外部分销员':'内部分销员'}}
          </div>
        </div>
        <el-table :data="gridData">
          <el-table-column property="total" label="成交总额/￥" align="center"></el-table-column>
          <el-table-column property="singular" label="成交单数" align="center"></el-table-column>
          <el-table-column property="customers" label="客户总数" align="center"></el-table-column>
          <el-table-column property="commission" label="累计佣金/￥" align="center"></el-table-column>
          <el-table-column property="exposure" label="曝光总数" align="center"></el-table-column>
          <el-table-column property="share" label="转发总数" align="center"></el-table-column>
        </el-table>
      </el-dialog>      
    </div>
</template>
<script>
import api from "@/api.js";
import {pagination} from "@/util/util.js";
import shenhe from "../tkShenhe/shenhe";
export default {
  name:'tkShenhe',
  components: {
    shenhe
  },
  filters: {//限制文本显示字数,超出部分用...代替
    ellipsis (value) {
        if (!value) return ''
        if (value.length > 25) {
          return value.slice(0,25) + '...'
        }
        return value
    },
  },
  data() {
    return {
      isshowDialog:false,//是否显示审核弹框
      shenheinfo:{},
      codeUrl:'',
      status_list: [],
      centerDialogVisible: false,
      timeData:'',
      conditionForm:{
        name:'',
        status:"",
        page:1
      },
      active:{},
      staffData: [{
        id:'',
        wx_nickname: '',
        head_image: '',
        register_time:'',
        status:1,
        openid:'',
        create_time_text:'',
        status_text:'',
        
      }],
      status:0,
      pages: {
        current_page: pagination.current_page,
        page_size: pagination.page_size,
        total_rows: pagination.total_rows
      },
      dialogTableVisible: false,
      recordData: {},
      gridData: []
    }
  },
  mounted() {
    this.getstaffData();
  },
  methods: {
    //获取核销员工信息
    getstaffData(){
      this.axios.post(api.recommendList,this.conditionForm)
      .then(res =>{
        if(res.data.code == 0){
         this.status_list = res.data.result.status_list;
          this.staffData = res.data.result.list//员工列表
          this.pages.page_size = res.data.page.page_size//每页显示条数
          this.pages.total_pages = res.data.page.total_pages//总页数
          this.pages.current_page = res.data.page.current_page//当前页
          this.pages.total = res.data.page.total_rows//总条数
        }
      })
    },
    //选择筛选时间
    changeTime(timeValue){
      if(timeValue){
        this.conditionForm.start_time = timeValue[0]
        this.conditionForm.end_time = timeValue[1]
      }else{
        this.conditionForm.start_time = ''
        this.conditionForm.end_time = ''
      }
    },
    //检索
    searchData(){
      this.conditionForm.page = 1;
      this.getstaffData()
    },
     // 重置检索
    onReset() {
      this.conditionForm.name = '';
      this.conditionForm.status = "";
      // this.conditionForm.type = 0;
      this.conditionForm.page = 1;
      this.getstaffData();
    },
    // 分页
    currentChange(page) {
      this.conditionForm.page = page;
      this.getstaffData();
    },
  
    // 通过
    changeRecommend(id,status){
      this.$confirm('是否确定进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
              this.axios
              .post(api.changeRecommend ,{id:id,status:status})
              .then(res=>{
                if(res.data.code == 0){
                  this.$message.success(res.data.msg);
                  // this.btnDisabled = false
                  this.getstaffData();
                }
              }).catch(res => {});
          })
          .catch(() => {
            // this.btnDisabled = false
            this.$message({
                type: 'info',
                message: '您已取消删除'
            });          
        });   
      
    },
 
    shenhe(id,status) {
      this.isshowDialog = true
      this.shenheinfo.id = id
      this.shenheinfo.status = status
      // this.$router.push({name: 'shenhe',params: { id: id,status:status }});
    },
     // 接收子组件qrcode事件
    updateData(option) {
       this.getstaffData();
    },
    // 查看分销数据
    getStaffInfo(id, type) {
      this.axios.post(api.recommendData, {id: id, user_type: type})
        .then(response => {
          if (response.data.code == 0) {
            this.recordData = response.data.result.recommend_info;
            this.gridData[0] = response.data.result.zonglan; 
            this.dialogTableVisible = true;
          }
        }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.status1{color: #29A7F4;}
.status2{color: #606266;}
.status3{color: #F54A4A;}
.status4{color: #F54A4A;}
</style>